module.exports = __webpack_public_path__ + "static/media/shulk_0.130da268.png";